module.exports = __webpack_public_path__ + "static/media/2-option2-4row.ccbaf220.png";